import { render, staticRenderFns } from "./Accesorios.vue?vue&type=template&id=38d29f7f&scoped=true"
import script from "./Accesorios.vue?vue&type=script&lang=js"
export * from "./Accesorios.vue?vue&type=script&lang=js"
import style0 from "./Accesorios.vue?vue&type=style&index=0&id=38d29f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d29f7f",
  null
  
)

export default component.exports